<template>
  <div v-loading="loading">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/" style="margin: 0 0 5px;">
        <el-breadcrumb-item>邀请函模板</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="margin: 10px 0;">请选择邀请函模板,然后点击模版上方“创建邀请函”:（微信邀请函只适用于平时使用微信的国内外客户，如果目标海外客户不使用微信，请选择“邮件邀请海外客户”方式）</div>
    <div class="createbox"><span class="createbtn" @click="createYqh">创建邀请函</span></div>
    <template>
      <div class="wrapClass">
        <div class="listCss" v-for="(item,index) in listArr" :key="index" :class="{'activeCss':activeVar==index}" @click="activeFun(item,index)">
          <p v-if="item.tempId == '6497'">模板一</p>
          <p v-else-if="item.tempId == '6498'">模板二</p>
          <p v-else-if="item.tempId == '6499'">模板三</p>
          <img :src="item.invitationImgUrl" />
        </div>
      </div>
		</template>
    <div v-show="showMZ" class="tc" id="mz">
      <div style="border-bottom: 1px solid #EFEFEF; padding:5px 15px; font-size: 16px;">邀请函模板【请使用微信扫描二维码】</div>
      <div style="border-bottom: 1px solid #EFEFEF; text-align: center; padding:10px 0; font-size: 18px;">请扫描下方二维码获得企业专属邀请函</div>
      <div>
        <div class="qrcode" id="qrcode" ref="qrcode" style="width: 100%; margin-top: 10px; text-align: center;"></div>
        <ul style="width: 80%; margin: 10px auto;">
          <li style="list-style: outside;">手机端操作请先截图此页面保存至相册，退出系统后，在微信界面点击右上角“+”下的扫一扫，选择相册里的截图识别二维码生成邀请函，即可转发给客户或发送至朋友圈。</li> 
          <li style="list-style: outside;">在电脑端操作此系统，可直接用手机扫上述二维码生成邀请函转发，或点击鼠标右键保存二维码运用到自身的宣传材料或自制邀请函里。</li>
          <li style="list-style: outside;">发送前请检查邀请函显示内容，如需修改请关闭本窗口，并返回至填充展商信息页面修改。</li>
          <li style="list-style: outside;">在<strong style="color: red;">已生成的邀请函</strong>界面点击右上角三个点，选择您要转发的微信好友，或者发送至朋友圈。提醒您的客户点击邀请函上的“<strong>马上预登记</strong>”按钮提交个人实名制信息，即可获得参观证件。</li>
            <!--<li style="list-style: outside;">您可通过“<strong>已邀请登记的客户名单</strong>”菜单随时查看已受邀完成登记的客户信息。</li>
            <li style="list-style: outside;">请提醒客户，参观展会必须随身携带身份证件原件，国内观众入场时刷身份证过闸机验证，海外观众需在登录柜台人工查验核对证件信息方可入场。</li>-->
          <li style="list-style: outside;">如在操作过程遇到任何问题，请致电<strong>010-85229645/85229093/85229831</strong>咨询。</li>
        </ul>
      </div>
      <div @click="close" style="width: 10%; cursor: pointer; text-align: center; background: #409EFF; color: #FFFFFF; margin:20px auto;">关闭</div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import img1 from '../../assets/1.png';
import img2 from '../../assets/2.png';
import img3 from '../../assets/1.png';
import QRCode from 'qrcodejs2'

export default {
  data(){
      return{
        activeVar:3,
        listArr: [],
        qrcode: '',
        showMZ: false,
        loading:true,
        atrID: localStorage.getItem('atrID'),
        bthCode: localStorage.getItem('bthCode'),
        ewmText: ''
      }
  },
  components: {},
  mounted() {
    this.geInvitation()
  },
  methods: {
    open () {
      this.showMZ = true
    },
    close () {
      this.showMZ = false
    },
    activeFun(item,index){
        // item 为被选中的元素体
        this.activeVar=index
    },
    geInvitation(){
      this.loading = false;
      this.pageLoader = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: '模板生成中，请稍后',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
      });
        api.generateinvitationletters({
          imgWidth:1024,
          dataSources: 'actor'
        }).then((res)=>{
          if(res.data.code =='200'){
            this.listArr = res.data.data
            this.pageLoader.close()
            this.loading = false;
          }
        })
    },
    createYqh(){
      if(this.activeVar == 3){
        alert('请选择邀请函模板')
      }else{
        if(this.listArr[this.activeVar].tempId == '6499'){
          this.ewmText = 'https://vis.eastfair.com/Public/wtt/24cfFx/index.html?atrID=' + this.atrID + '&dbname=' + this.listArr[this.activeVar].dbName + '&tmpid=' + this.listArr[this.activeVar].tempId + '&bthCode=' + this.bthCode + '&language=' + 'en'
        }else{
          this.ewmText = 'https://vis.eastfair.com/Public/wtt/24cfFx/index.html?atrID=' + this.atrID + '&dbname=' + this.listArr[this.activeVar].dbName + '&tmpid=' + this.listArr[this.activeVar].tempId + '&bthCode=' + this.bthCode + '&language=' + 'cn'
        }
        this.showMZ = true
        document.getElementById("qrcode").innerHTML = ""
        this.qrcode = new QRCode('qrcode', {
          width: 150,
          height: 150,
          //this.listArr[this.activeVar].tempId
          text: this.ewmText
        })
      }
    }

  }
}
</script>
<style lang="less">
.el-radio{
	width: 30% !important;
	position: relative;
}
.bor{
	border: #409EFF;
}
.el-radio__input{
}
.el-radio__label{
	width: 100%;
	display: inline-block;
}
.el-radio__label img{
	width: 100%; 
	display: inline-block;
}
.wrapClass{
	width: 100%;
	overflow: hidden;
}
.wrapClass p{
	line-height: 0.3rem;
}
.listCss{
	float: left;
	margin: 0 2%;
  cursor: pointer;
  width: 20%;
  text-align: center;
}
.listCss img{
	display: inline-block;
  width: 100%;
}
.listCss p{
	font-size: 0.1rem;
	font-weight: bold;
	color: #409eff;
}
.activeCss{
 border: 3px solid #409eff;
}
.qrcode img{
	margin: 0 auto;
}
.createbox{
  width: 70%;
  text-align: center;
  .createbtn{
    cursor: pointer;
    margin: 0px auto;
    display: block;
    width: 15%;
    background: rgb(64, 158, 255);
    color: rgb(255, 255, 255);
    padding: 10px;
    font-size: 14px;
    border-radius: 5px;
  }
}
.tc{
  position: fixed;
  z-index: 100;
    background: rgb(255, 255, 255);
    top: 0px;
    left: 25%;
    width: 50%;
    box-sizing: border-box;
    height: auto;
    border: 1px solid rgb(239, 239, 239);
    border-radius: 10px;
    margin: 2%;
    color: rgb(0, 0, 0);
    text-align: justify;
    line-height: 26px;
}
@media screen and (max-width:540px){
  .listCss{
    margin: 2%;
    cursor: pointer;
    width: 95%;
    text-align: center;
  }
  .listCss p{
    font-size: 0.4rem;
    font-weight: bold;
    color: #409eff;
    line-height: 2rem !important;
  }
  .createbox{
    width: 100%;
    text-align: center;
    .createbtn{
      cursor: pointer;
      margin: 10px auto;
      display: block;
      width: 50%;
      background: rgb(64, 158, 255);
      color: rgb(255, 255, 255);
      padding: 10px;
      font-size: 14px;
      border-radius: 5px;
    }
  }
  .tc{
    position: fixed;
    z-index: 100;
    background: rgb(255, 255, 255);
    top: 0px;
    left: 0;
    width: 96%;
    box-sizing: border-box;
    height: 95%;
    border: 1px solid rgb(239, 239, 239);
    border-radius: 10px;
    margin: 2%;
    color: rgb(0, 0, 0);
    text-align: justify;
    line-height: 26px;
    overflow: scroll;
	}
}
</style>

